import { useState } from "react";
import { C } from "../utils/tokens";
import { FInput, Btn } from "../components/primitives";
import { getSkillsForTemplate } from "../utils/skillsByCategory";

const Step4 = ({ d, s, tpl }) => {
  const [inp, si] = useState("");
  const suggestions = getSkillsForTemplate(tpl);

  const add = () => {
    if (inp.trim() && !d.includes(inp.trim())) {
      s([...d, inp.trim()]);
      si("");
    }
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: 20 }}
      className="au"
    >
      <div>
        <h2
          style={{
            fontFamily: "'Syne',sans-serif",
            fontSize: 26,
            fontWeight: 800,
            marginBottom: 5,
          }}
        >
          Competenze
        </h2>
        <p style={{ color: C.muted, fontSize: 13.5 }}>
          Skill, lingue, strumenti — suggeriti per il tuo settore.
        </p>
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <FInput
          value={inp}
          onChange={si}
          placeholder="Aggiungi competenza..."
        />
        <Btn onClick={add}>+ Add</Btn>
      </div>
      <div>
        <div
          style={{
            fontSize: 10.5,
            color: C.muted,
            fontFamily: "'DM Mono',monospace",
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            marginBottom: 10,
          }}
        >
          Suggeriti per {tpl?.cat || "il tuo settore"}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 7 }}>
          {suggestions
            .filter((x) => !d.includes(x))
            .slice(0, 16)
            .map((x) => (
              <button
                key={x}
                onClick={() => s([...d, x])}
                style={{
                  padding: "5px 11px",
                  borderRadius: 6,
                  border: `1px solid ${C.border}`,
                  background: "transparent",
                  color: C.muted,
                  fontSize: 12,
                  transition: "all 0.15s",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = C.goldBorder;
                  e.currentTarget.style.color = C.gold;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = C.border;
                  e.currentTarget.style.color = C.muted;
                }}
              >
                + {x}
              </button>
            ))}
        </div>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {d.map((sk, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 7,
              background: C.goldDim,
              border: `1px solid ${C.goldBorder}`,
              borderRadius: 7,
              padding: "6px 12px",
            }}
          >
            <span style={{ fontSize: 13, color: C.gold }}>{sk}</span>
            <button
              onClick={() => s(d.filter((_, j) => j !== i))}
              style={{
                background: "none",
                border: "none",
                color: "rgba(245,197,24,0.4)",
                fontSize: 11,
                padding: 0,
                lineHeight: 1,
                cursor: "pointer",
                transition: "color 0.15s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = C.danger)}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = "rgba(245,197,24,0.4)")
              }
            >
              ✕
            </button>
          </div>
        ))}
        {d.length === 0 && (
          <p style={{ color: C.muted, fontSize: 13 }}>
            Nessuna competenza ancora.
          </p>
        )}
      </div>
    </div>
  );
};

export default Step4;
